import React from 'react';
import { connect } from 'react-redux';
import { Heading1 } from '../../ui/Typography/Heading';
import { updateConfigOnboardingSettings } from '../../../redux/config/slice';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { OnboardingActions } from '../OnboardingActions/OnboardingActions';
import { selectUpdateConfigLoading } from '../../../redux/config/selectors';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import {
  OnboardingContent,
  OnboardingHeaderGroup,
  OnboardingContentGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingContentGroupText,
  OnboardingContentGroupLink
} from '../../ui/Layout/OnboardingLayout';

const ONBOARDING_HELP_CENTER_URL =
  'https://help.oqio.de/de/collections/18284469-erste-schritte-einfuhrung?utm_source=onboarding&utm_medium=inproduct';

export const OnboardingStepInitialComponent = ({ updateConfigOnboardingSettings, updateConfigLoading }) => {
  const handleOnNext = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.OVERVIEW_ORGANIZATION });
  };

  return (
    <>
      <OnboardingNavbar logoutLabel="Abmelden" loading={updateConfigLoading} />
      <OnboardingContent className="step-initial">
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup className="no-border">
            <OnboardingContentTitle>
              <Heading1>Willkommen in Ihrem Versicherungsportal!</Heading1>
            </OnboardingContentTitle>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="no-border">
            <OnboardingContentGroupText>
              Danke für Ihr Vertrauen in unsere Lösung zur digitalen Versicherungsverwaltung von Immobilien.
            </OnboardingContentGroupText>
            <OnboardingContentGroupText>
              In wenigen Schritten richten wir Ihr Konto ein und machen Sie startklar für einen effizienten und
              revisionssicheren Workflow.
            </OnboardingContentGroupText>
            <OnboardingContentGroupText>
              Für Hilfestellungen bei der Einführung können Sie jederzeit im Help Center nachschlagen.
            </OnboardingContentGroupText>
            <OnboardingContentGroupLink href={ONBOARDING_HELP_CENTER_URL} target="_blank" rel="noopener noreferrer">
              Zum Help Center
            </OnboardingContentGroupLink>
          </OnboardingContentGroup>

          <OnboardingActions
            centered
            className="step-initial"
            onNext={handleOnNext}
            nextLabel="Einführung starten"
            nextIcon={false}
            loading={updateConfigLoading}
          />
        </OnboardingStepWrapper>
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateConfigLoading: selectUpdateConfigLoading(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings
};

export const OnboardingStepInitial = connect(mapStateToProps, mapDispatchToProps)(OnboardingStepInitialComponent);
